import { useContext, useState, useEffect } from 'react';
import { ModalContext } from '../../components/contexts';
import ValidateService from '../../services/ValidateService';
import { isValidPassword } from '../../services/UtilService'; // isValidPassword 함수 import
import { NumericFormat } from 'react-number-format';
import { useNavigate, useLocation } from 'react-router-dom';
import { nlPost } from '../../apis/notLoginApi';

const UserJoin = () => {
  useEffect(() => {
    document.title = '사용자 가입 - 정보 입력';
  }, []);

  const { modalService } = useContext(ModalContext);
  const validateService = new ValidateService(modalService);
  const [dplChkRslt, setDplChkRslt] = useState(null);
  const [dplChkBool, setDplChkBool] = useState(false);

  const [pswdCompare, setPswdCompare] = useState(null);
  const [pswdValid, setPswdValid] = useState(null);
  const [pswdValidMsg, setPswdValidMsg] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [entData, setEntData] = useState([]);
  const [userIdChg, setUesrIdChg] = useState(false);
  const location = useLocation();

  const [searchMethod, setSearchMethod] = useState('entNm'); // 검색 방법
  const [searchValue, setSearchValue] = useState(''); // 검색 값

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    userId: '',
    userPswd: '',
    userPswdConfirm: '',
    userNm: '',
    userTelno: '',
    userMblTelno: '',
    entNm: '',
    entSn: '',
    brno: '',
    userEml: '',
    utztnTrmsAgreYn: '',
    prvcClctAgreYn: '',
  });

  // 비밀번호와 비밀번호 확인 필드 비교
  useEffect(() => {
    setPswdCompare(
      formData.userPswd === formData.userPswdConfirm ? true : false
    );
  }, [formData.userPswd, formData.userPswdConfirm]);

  // 비밀번호 유효성 검사 useEffect
  useEffect(() => {
    if (
      pswdCompare == true &&
      formData.userPswd != '' &&
      formData.userPswdConfirm != '' &&
      formData.userPswd.length >= 8 &&
      formData.userPswdConfirm.length >= 8
    ) {
      validatePassword();
    } else if (pswdCompare == false) {
      setPswdValidMsg('비밀번호가 일치하지 않습니다.');
      setPswdValid(false);
    }
  }, [pswdCompare]);
  //validatePassword
  // 비밀번호 유효성 검사 결과를 저장하는 상수를 활용

  const validatePassword = () => {
    const result = isValidPassword(formData.userPswd); // utilService에서 가져온 함수 호출

    if (result) {
      setPswdValidMsg(result); // 에러 메시지를 설정
      setPswdValid(false); // 유효하지 않은 경우 처리
    } else {
      setPswdValidMsg('사용 가능한 비밀번호입니다.'); // 유효한 경우 메시지
      setPswdValid(true); // 유효한 경우 처리
    }
  };

  // 입력값 state에 저장
  const handleInputChange = e => {
    const { id, value } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [id]: value,
    }));
  };

  // 아이디 비밀번호 입력 input 스페이스 금지
  const handleKeyDown = e => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  // 아이디 영문, 숫자만 입력
  const handleInput = e => {
    const { id, value } = e.target;

    if (/^[a-zA-Z0-9]*$/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    } else {
      e.preventDefault();
    }
  };

  const handleInputChangeName = e => {
    const { id, value } = e.target;
    // 숫자가 포함되지 않은 경우에만 상태를 업데이트
    if (!/\d/.test(value)) {
      setFormData(prevFormData => ({
        ...prevFormData,
        [id]: value,
      }));
    }
  };

  // 아이디 비밀번호 입력 input 붙여넣기 금지
  const handlePaste = e => {
    e.preventDefault();
  };

  // 아이디 중복확인
  const fnDplChk = () => {
    const url = '/member/duplicateIdChk.do';
    const param = {
      id: formData.userId.replace(/\s+/g, ''),
    };

    if (param.userId != '') {
      nlPost(url, param)
        .then(response => {
          setDplChkBool(response);
          if (response instanceof Error) {
            this.modalService.errorAlert(
              '데이터 처리중 에러가 발생하였습니다',
              () => {}
            );
          } else {
            if (response == false) {
              setDplChkRslt('사용 불가능한 아이디입니다.');
              setDplChkBool(false);
            } else if (response == true) {
              setDplChkRslt('사용 가능한 아이디입니다.');
              setDplChkBool(true);
            }
          }
        })
        .catch(error => {});
    } else if (param.userId == '') {
      setDplChkRslt('아이디를 입력해주세요.');
    }
  };

  useEffect(() => {
    setUesrIdChg(false);
  }, [formData.userId]);

  const joinProcess = async () => {
    try {
      const isDuplicateChecked = await dplChk();

      if (isDuplicateChecked === false) return;

      const isValidation = await validationCheck();

      if (isValidation === false) return;
    } catch (error) {
      await modalService.errorAlert(
        '데이터 처리 중 에러가 발생하였습니다.',
        () => {}
      );
    }
  };

  const validationCheck = async () => {
    const validationRules = {
      userId: { presence: true },
      userPswd: { presence: true },
      userPswdConfirm: { presence: true },
      userNm: { presence: true },
      userTelno: { presence: true },
      userMblTelno: { presence: true },
      entNm: { presence: true },
      userEml: { presence: true, email: true },
      picDept: { presence: true },
      wrkrRole: { presence: true },
      utztnTrmsAgreYn: { presence: true },
      prvcClctAgreYn: { presence: true },
    };

    const altKey = {
      userId: '아이디',
      userPswd: '비밀번호',
      userPswdConfirm: '비밀번호 확인',
      userNm: '이름',
      userTelno: '전화번호',
      userMblTelno: '휴대전화',
      entNm: '기업',
      userEml: '이메일',
      picDept: '부서',
      wrkrRole: '직책',
      utztnTrmsAgreYn: '이용약관 동의',
      prvcClctAgreYn: '개인정보 수집 동의',
    };

    if (
      await validateService.validateJsCall(formData, validationRules, altKey)
    ) {
      return;
    }

    if (formData.userPswd !== formData.userPswdConfirm) {
      modalService.noticeAlert('비밀번호가 일치하지 않습니다.', () => {});
      return;
    }

    if (!pswdValid) {
      modalService.noticeAlert(
        '비밀번호는 8자 이상, 영문, 숫자, 특수문자를 포함해야 합니다.',
        () => {}
      );
      return;
    }

    await insertUser();
  };

  const dplChk = async () => {
    if (!dplChkBool) {
      await modalService.errorAlert('아이디 중복확인을 해주세요.', () => {}); // ✅ 모달이 닫힌 후 다음 코드 실행
      return false;
    }

    return true;
  };

  const insertUser = async () => {
    const url = '/member/insertUser.do';
    try {
      await nlPost(url, formData);
      navigateTo('/member/joinCmplt');
    } catch (error) {}
  };

  const searchEnt = () => {
    const param = {
      entNm: searchValue || '',
      brno: searchValue || '',
      searchMethod: searchMethod,
    };
    const url = '/member/entList.do';
    nlPost(url, param)
      .then(response => {
        setEntData(response);
      })
      .catch(error => {});
  };

  const closeModal = () => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
  };

  const navigateTo = url => {
    navigate(url);
  };

  const entSelect = entSn => {
    setShowModal(false);
    setEntData([]);
    setSearchValue('');
    setSearchMethod('entNm');
    const selectedEnt = entData.find(ent => ent.entSn === entSn);
    if (selectedEnt) {
      setFormData(prevFormData => ({
        ...prevFormData,
        entNm: selectedEnt.entNm,
        entSn: selectedEnt.entSn,
        brno: selectedEnt.brno,
      }));
    }
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showModal]);

  const [placeHolderMsg, setPlaceHolderMsg] = useState('기업명을 검색해주세요');

  const handleSearchMethodChange = e => {
    setSearchMethod(e.target.value);
  };

  useEffect(() => {
    if (searchMethod === 'entNm') {
      setPlaceHolderMsg('기업명을 검색해주세요');
    } else if (searchMethod === 'brno') {
      setPlaceHolderMsg('사업자등록번호를 검색해주세요');
    }
  }, [searchMethod]);

  useEffect(() => {
    if (location.state && location.state.userEml) {
      setFormData(prevFormData => ({
        ...prevFormData,
        userEml: location.state.userEml,
        utztnTrmsAgreYn: location.state.utztnTrmsAgreYn,
        prvcClctAgreYn: location.state.prvcClctAgreYn,
      }));
    }
  }, [location.state]);

  const cancel = () => {
    navigateTo('/member/login');
  };

  const [isDisabled, setIsDisabled] = useState(true);

  useEffect(() => {
    if (formData.userId !== undefined && formData.userId !== null) {
      if (formData.userId.length >= 6) {
        setIsDisabled(false);
      }
      if (formData.userId.length < 6) {
        setIsDisabled(true);
      }
    }
  }, [formData.userId]);

  const openModal = () => {
    searchEnt();
    setShowModal(true);
  };

  return (
    <>
      <div className="page-title-wrap" data-type="responsive">
        <h2 className="h-tit">사용자 가입</h2>
      </div>
      <ol className="step-wrap">
        <li className="done">
          <span>
            <i className="sr-only">1단계</i>
            <span className="step-tit">가입 유형 선택</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">2단계</i>
            <span className="step-tit">중복가입 확인</span>
          </span>
        </li>
        <li className="done">
          <span>
            <i className="sr-only">3단계</i>
            <span className="step-tit">약관동의</span>
          </span>
        </li>
        <li className="active">
          <span>
            <i className="sr-only">4단계 현재단계</i>
            <span className="step-tit">정보입력</span>
          </span>
        </li>
        <li>
          <span>
            <i className="sr-only">5단계</i>
            <span className="step-tit">사용자 가입 완료</span>
          </span>
        </li>
      </ol>

      <h3 className="content-tit">정보입력</h3>
      <p className="text-gray-70">
        사용자 가입시 입력하신 정보는 사용자님의 동의 없이 공개되지 않으며,
        개인정보보호 정책에 따라 안전하게 보호받습니다.
      </p>
      <p className="tbl-msg gap-sm">
        <em className="star-require">*</em> 표시는 필수 입력 사항입니다.
      </p>
      <div className="txt-box bg-white">
        <h4>사용자 정보</h4>
        <fieldset>
          <legend>사용자 정보 입력</legend>
          <div className="fieldset">
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="userId">
                  아이디<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <div className="input-group">
                  <input
                    type="text"
                    id="userId"
                    className="form-control"
                    placeholder="아이디를 입력해 주세요"
                    value={formData.userId || ''}
                    onChange={handleInput}
                    onKeyDown={handleKeyDown} // 아이디 스페이스바 금지
                    onPaste={handlePaste} // 아이디 붙여넣기 금지
                    maxLength={20}
                    aria-labelledby="userId"
                    disabled={dplChkBool}
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={fnDplChk} // 아이디 중복검사 함수 호출
                    disabled={isDisabled}
                  >
                    중복 확인
                  </button>
                </div>
              </div>
              {dplChkRslt !== null ? (
                <p
                  className={
                    dplChkBool == false ? 'text-point' : 'text-secondary'
                  }
                >
                  {dplChkRslt}
                </p>
              ) : null}
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="userPswd">
                    비밀번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <label className="hidden-label" htmlFor="userPswd">
                    라벨
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="userPswd"
                    value={formData.userPswd || ''}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown} // 비밀번호 스페이스바 금지
                    onPaste={handlePaste} // 비밀번호 붙여넣기 금지
                    maxLength={20}
                    aria-labelledby="userPswd"
                  />
                </div>
                <div style={{ height: '25.5px' }}>
                  {pswdValid !== null ? (
                    <p
                      className={
                        pswdCompare == true && pswdValid == true
                          ? 'text-secondary'
                          : 'text-point'
                      }
                    >
                      {pswdValidMsg}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="userPswdConfirm">
                    비밀번호 확인<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <label className="hidden-label" htmlFor="userPswdConfirm">
                    라벨
                  </label>
                  <input
                    type="password"
                    className="form-control"
                    id="userPswdConfirm"
                    value={formData.userPswdConfirm || ''}
                    onChange={handleInputChange}
                    onPaste={handlePaste} // 클립보드 내용 붙여넣기 방지
                    maxLength={20}
                    aria-labelledby="userPswdConfirm"
                  />
                </div>
                <div style={{ height: '25.5px' }}></div>
              </div>
            </div>
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="userNm">
                  이름<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts" style={{ Pdth: '64.4%' }}>
                <label className="hidden-label" htmlFor="userNm">
                  라벨
                </label>
                <input
                  type="text"
                  id="userNm"
                  value={formData.userNm || ''}
                  onChange={handleInputChangeName}
                  className="form-control"
                  maxLength={20}
                  aria-labelledby="userNm"
                />
              </div>
            </div>
            <div className="input-group">
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="userTelno">
                    전화번호<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="userTelno"
                    className="form-control"
                    value={formData.userTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    allowNegative={false}
                    aria-labelledby="userTelno"
                  />
                </div>
              </div>
              <div className="form-group">
                <div className="form-title">
                  <label htmlFor="userMblTelno">
                    휴대전화<em className="star-require">*</em>
                  </label>
                </div>
                <div className="form-conts">
                  <NumericFormat
                    type="text"
                    id="userMblTelno"
                    className="form-control"
                    value={formData.userMblTelno || ''}
                    onChange={handleInputChange}
                    thousandSeparator={false}
                    allowNegative={false}
                    maxLength={11}
                    allowLeadingZeros={true}
                    aria-labelledby="userMblTelno"
                  />
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <h4 className="gap-md">소속기업 정보</h4>
        <fieldset>
          <legend>소속기업 정보 입력</legend>
          <div className="fieldset">
            <div className="form-group">
              <div className="form-title">
                <label htmlFor="entNm">
                  기업명<em className="star-require">*</em>
                </label>
              </div>
              <div className="form-conts">
                <div className="input-group">
                  <input
                    type="text"
                    id="entNm"
                    className="form-control"
                    value={formData.entNm || ''}
                    aria-labelledby="entNm"
                  />
                  <button
                    type="button"
                    className="btn secondary"
                    onClick={() => {
                      // setShowModal(true);
                      openModal();
                    }}
                  >
                    검색
                  </button>{' '}
                </div>
              </div>
            </div>
          </div>
        </fieldset>
        <div className="input-group">
          <div className="form-group">
            <div className="form-title">
              <label htmlFor="picDept">
                부서<em className="star-require">*</em>
              </label>
            </div>
            <div className="form-conts">
              <input
                type="text"
                className="form-control"
                id="picDept"
                value={formData.picDept || ''}
                onChange={handleInputChange}
                maxLength={20}
                aria-labelledby="picDept"
              />
            </div>
          </div>
          <div className="form-group">
            <div className="form-title">
              <label htmlFor="wrkrRole">
                직책<em className="star-require">*</em>
              </label>
            </div>
            <div className="form-conts">
              <label className="hidden-label" htmlFor="wrkrRole">
                라벨
              </label>
              <input
                type="text"
                className="form-control"
                id="wrkrRole"
                value={formData.wrkrRole || ''}
                onChange={handleInputChange}
                maxLength={20}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="page-btn-wrap">
        <button type="button" className="btn xlg tertiary" onClick={cancel}>
          취소
        </button>
        <button
          type="button"
          className="btn xlg primary"
          onClick={() => {
            joinProcess();
          }}
        >
          회원가입 완료
        </button>
      </div>
      {showModal && (
        <div
          className="modal fade in shown"
          role="dialog"
          aria-labelledby="tit_search_pwd"
          aria-hidden={!showModal}
        >
          <div className="modal-dialog sm">
            <div className="modal-content">
              <div className="modal-header">
                <h2 id="tit_search_corp" className="modal-title">
                  기업정보검색
                </h2>
              </div>
              <div className="modal-conts">
                <div className="txt-box search-corp">
                  <fieldset>
                    <legend>기업검색</legend>
                    <div className="form-group">
                      <div className="form-conts">
                        <select
                          className="form-select"
                          title="선택"
                          style={{ width: '50%' }}
                          onChange={handleSearchMethodChange}
                        >
                          <option value="entNm">기업명</option>
                          <option value="brno">사업자등록번호</option>
                        </select>
                        <label className="hidden-label" htmlFor="searchValue">
                          라벨
                        </label>
                        <div className="input-group">
                          <input
                            type="text"
                            id="searchValue"
                            value={searchValue || ''}
                            onChange={() => {
                              setSearchValue(event.target.value);
                            }}
                            className="form-control"
                            placeholder={placeHolderMsg}
                            aria-labelledby="searchValue"
                          />
                          <button
                            type="button"
                            className="btn secondary"
                            onClick={() => {
                              searchEnt();
                            }}
                          >
                            검색
                          </button>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                {/* 기업정보 테이블 시작*/}
                {entData.length > 0 && (
                  <div className="tbl-wrap">
                    <table className="tbl col data">
                      <caption>
                        기업정보 검색 표로 선택, 사업체명, 사업자등록번호
                        주소등으로 구성되어있음
                      </caption>
                      <colgroup>
                        <col style={{ width: '10%' }} />
                        <col style={{ width: '20%' }} />
                        <col style={{ width: '10%' }} />
                        <col />
                      </colgroup>
                      <thead>
                        <tr>
                          <th scope="col">선택</th>
                          <th scope="col">사업체명</th>
                          <th scope="col">사업자등록번호</th>
                          <th scope="col">주소</th>
                        </tr>
                      </thead>
                      <tbody>
                        {entData.map(entData => (
                          <tr key={entData.entSn}>
                            <th>
                              <button
                                type="button"
                                className="btn primary"
                                onClick={() => {
                                  entSelect(entData.entSn);
                                }}
                              >
                                선택
                              </button>
                            </th>
                            <td>{entData.entNm}</td>
                            <td>{entData.brno}</td>
                            <td>{entData.entAddr}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {/* 기업정보 테이블 끝*/}
              </div>
              <div className="modal-btn btn-wrap"></div>
              <button
                type="button"
                className="btn-close close-modal"
                onClick={() => {
                  closeModal();
                }}
              >
                <span className="sr-only">닫기</span>
              </button>
            </div>
          </div>
          <div className="modal-back in"></div>
        </div>
      )}
    </>
  );
};

export default UserJoin;
